export const isPhone = /^1[3-9]\d{9}$/

export const isEmail = /(^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$)/

export const isPhoneOrEmail = /(^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$)|(^1[3-9]\d{9}$)/

export const isPrice = /^([1-9]\d{0,9}|0)([.]?(\.\d{1,2})?)$/

export const isPositiveInteger = /^[6-9]$|^[1-9]\d{1}$|^1[0-1][0-9]$|^120$/

export const isPassword = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[`~!@#$%^&*()_\-=+,.<>?/"':;{}[\]|\\])[0-9a-zA-Z`~!@#$%^&*()_\-=+,.<>?/"':;{}[\]|\\]{8,18}$/
